/**
 * loginActions.js
 * Created by michaelbray on 2/13/18.
 */

import axios from 'axios';
import { LOGIN_SUCCESS, LOGIN_FAILED,LOCKOUT,LOGOUT_SUCCESS, HIDE_LOGIN_MODAL, MFA_REQUIRED, SHOW_LOGIN_MODAL, ACCOUNT_SERVICE_STATUS_UPDATED } from '../../actions/actionTypes';

const loginSucceeded = (profile) => ({
    type: LOGIN_SUCCESS,
    profile
});

const loginFailed = () => ({
    type: LOGIN_FAILED
});

const lockout = () => ({
    type: LOCKOUT
});

const logoutSucceeded = () => ({
    type: LOGOUT_SUCCESS
});

const mfaRequired = () => ({
    type: MFA_REQUIRED
});

const serviceStatusUpdated = (enabled, preview_banner_enabled) => ({
    type: ACCOUNT_SERVICE_STATUS_UPDATED,
    enabled,
    preview_banner_enabled
});

export const login = (loginData) => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/login`;
            const response = await axios.post(url, loginData);
            const profile = response.data;
            window.localStorage.setItem('recaccount', JSON.stringify(profile));

            if (window.dataLayer) {
                window.dataLayer.push({
                    userID: profile.account.account_id
                });
            }

            dispatch(loginSucceeded(profile));
        }
        catch (error) {
            if (error.response && error.response.data && error.response.data.error === 'mfa') {
                dispatch(mfaRequired());
            }
 else if (error.response && error.response.data && error.response.data.error === 'lockout') {
                dispatch(lockout())
            }
            else {
                dispatch(loginFailed());
            }
        }
    };
};

export const loggedIn = (profileData) => {
    return (dispatch) => {
        dispatch(loginSucceeded(profileData));
    };
};

export const logout = () => {
    return (dispatch) => {
        if (window.localStorage) {
            window.localStorage.clear();
        }
        if (window.sessionStorage) {
            window.sessionStorage.clear();
        }
        dispatch(logoutSucceeded());
    };
};

export const clearShowLoginModal = () => {
    return (dispatch) => {
        dispatch({
            type: HIDE_LOGIN_MODAL
        });
    };
};

export const showLoginModal = () => {
    return (dispatch) => {
        dispatch({
            type: SHOW_LOGIN_MODAL
        });
    };
};

export const updateAccountServiceStatus = () => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/status`;
            const response = await axios.get(url);

            const enabled = response.data.enabled;
            const bannerEnabled = response.data.preview_banner_enabled ? response.data.preview_banner_enabled : false;

            dispatch(serviceStatusUpdated(enabled, bannerEnabled));
        }
        catch (error) {
            dispatch(serviceStatusUpdated(true, false));
        }
    };
};
